import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, CardHeader, Box } from '@mui/material';
import { subMonths, addMonths, format } from 'date-fns';
import { useChart } from '../../../components/chart';

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function AppWebsiteVisits({ title, subheader, chartLabels, chartData, ...other }) {
  let paddedLabels = chartLabels;
  let paddedData = chartData;

  if (chartLabels.length === 1) {
    const onlyDate = new Date(chartLabels[0]);
    const before = format(subMonths(onlyDate, 1), 'MMM yy');
    const current = format(onlyDate, 'MMM yy');
    const after = format(addMonths(onlyDate, 1), 'MMM yy');

    paddedLabels = [before, current, after];

    paddedData = chartData.map((dataSet) => ({
      ...dataSet,
      data: [null, ...dataSet.data, null],
    }));
  } else {
    // format all labels for uniformity
    paddedLabels = chartLabels.map((label) => format(new Date(label), 'MMM yy'));
  }

  const columnWidth = paddedLabels.length <= 4 ? '80px' : '40%'; // Max width for 1–4 bars

  const chartOptions = useChart({
    chart: { type: 'bar' },
    plotOptions: {
      bar: {
        columnWidth,
        distributed: false,
      },
    },
    fill: { type: chartData.map((i) => i.fill) },
    labels: paddedLabels,
    xaxis: {
      type: 'category',
      categories: paddedLabels,
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => (typeof y === 'number' ? `$ ${y.toFixed(0)}` : ''),
      },
    },
  });

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart type="bar" series={paddedData} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
}
